import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getLocalStorageData from '../utlis/storageUtils';
import { BASE_API_URL } from '../constants';
import { getHeaders } from '../utlis/security';

export const myAccountPageApi = createApi({
  reducerPath: 'myAccountPageApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: "https://apiv2.shwenarsin.com/api/app",
    prepareHeaders: async (headers) => {
      const customHeaders = await getHeaders('myAccountPageApi');
      for (const [key, value] of Object.entries(customHeaders)) {
        headers.set(key, value);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchMyAccountData: builder.query({
      query: (option) => ({
        url : 'myaccount',
        method: 'POST',
        body : {
            "phone": "",
            "platform": "miniapp",
            "udid": "190740e5f0032702",
            "user_id":  getLocalStorageData(),
            "version_code": 29,
            "version_name": "1.2.9"
        },
      }), 
    })
  }),
});

export const { useFetchMyAccountDataQuery, endpoints } = myAccountPageApi;